import getters from './getters';
import actions from './actions';
import mutations from './mutations';

export default {
  namespaced: true,
  state: {
    days: [],
    profile: {
      hero_images: [],
      profile: {},
      module: [],
    },
    delivery_option: [],
    delivery_method: [],
    payment_method: [],
    config: {},
    social_auth: [],
    merchant_delivery_options: [],
    home_delivery_options: [],
  },
  actions,
  mutations,
  getters,
};
